import {Box} from 'exsportia-components'
import {FC} from 'react'
import {useNavigate} from 'react-router-dom'

import {AddonErrorLike, getAddonErrorMessage} from '../../helpers/addon-error'
import {Button} from '../../ui/components/button/button'
import {InfoMessage} from '../../ui/components/info-message/info-message'
import {useLocale} from '../../utils/i18n'

// When the server refuses an add-on line in the price quote (RENTAL_INVALID), say so in plain words and let the
// customer go back to the Participants step to fix it. Shows nothing for any other error.
export const AddonQuoteProblem: FC<{error?: AddonErrorLike | null}> = ({error}) => {
  const {l} = useLocale()
  const navigate = useNavigate()
  const message = getAddonErrorMessage(error, (key, options) => l(key, options))
  if (!message) {
    return null
  }
  return (
    <Box
      mb='16px'
      data-testid='addon-quote-problem'
    >
      <InfoMessage
        text={message}
        preset='error'
      />
      <Box mt='8px'>
        <Button
          type='secondary'
          onClick={() => navigate(-1)}
        >
          {l('addon_error_change')}
        </Button>
      </Box>
    </Box>
  )
}
